import WrappedLayout from "./wrapPageElement";
import "./src/styles/global.css";
import "katex/dist/katex.min.css";
import "@fontsource/open-sans";

export const wrapPageElement = WrappedLayout;